import { Input } from 'antd';
import oddsApi from 'api/oddsApi';
import walletApi from 'api/walletApi';
import { useAppDispatch, useAppSelector, useAppTranslation, useErrTranslation } from 'app/hooks';
import InfomationIcon from 'assets/icons/InfomationIcon';
import { showConfirmModal, showErrorModal, showSuccessModal } from 'components/Modals/CommonModals';
import { PLACE_BET_AUDIO } from 'consts/app';
import Typo from 'consts/typography';
import {
  changeSingleAmount,
  changeSingleFutureAmount,
  selectBets,
  selectFutureBets,
  setFetchMyBet,
} from 'features/home/homeSlice';
import { useHandleGetWallets } from 'hooks/useHandleGetWallets';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useUserDetail from 'hooks/useUserDetail';
import { PlacingBet } from 'models';
import React, { useState } from 'react';
import { platformStates } from 'redux/platformSlice';
import BetInformationItem from './BetInformationItem';
import FutureBetInformationItem from './FutureBetInformationItem';
import CustomAmounBettButton from 'components/Commons/CustomAmountBetButton';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import { useHandleInsufficientBalance } from 'hooks/useHandleInsufficientBalance';
import BetSlipInformationItem from './BetSlipInformationItem';

interface SingleBetItemProps {
  id: string;
  onDelete: (id: string) => void;
  type: string;
}
const aud = new Audio(PLACE_BET_AUDIO);
const SingleBetItem: React.FunctionComponent<SingleBetItemProps> = ({ id, onDelete, type }) => {
  const t = useAppTranslation();
  const { currentUser } = useUserDetail();
  const { isDesktop, isLargeDesktop } = useAppSelector(platformStates);
  const dispatch = useAppDispatch();
  const { getWallet } = useHandleGetWallets();
  const et = useErrTranslation();
  const bets = useAppSelector(selectBets);
  const futureBets = useAppSelector(selectFutureBets);

  const handleResponseError = useHandleResponseError();
  const handleInsufficientBalance = useHandleInsufficientBalance();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9]{1,10}$/;
    const value = event.target.value;
    if (value === '' || regex.test(value)) {
      type === 'BET_GAME'
        ? dispatch(changeSingleAmount({ id, amount: Number(value) }))
        : dispatch(changeSingleFutureAmount({ id, amount: Number(value) }));
    }
  };

  const onOk = async (value: string) => {
    setIsLoading(true);
    let bettingAmount = Number(value);
    let request: PlacingBet = {
      amount: bettingAmount,
      oddsId: id,
    };
    if (type === 'BET_GAME') {
      const result = bets.find((bet) => bet.odd.id === id);
      request.market = result?.odd.market;
      request.gameId = result?.gameId;
    } else {
      const result = futureBets.find((bet) => bet.odd.id === id);
      request.futureId = result?.futureId;
    }
    const { ok, error } = await oddsApi.placingBets({
      bets: [request],
    });
    setIsLoading(false);
    if (ok) {
      aud.play();
      getWallet();
      dispatch(setFetchMyBet(true));
      showSuccessModal({
        title: t('bet.success.title'),
        content: t('bet.success.message'),
      });
    }
    if (error) {
      if (error.message === 'error.validate.balance.insufficient') {
        return handleInsufficientBalance();
      }
      if (error?.fieldErrors) {
        showErrorModal({
          content: et(error.fieldErrors.bets[0]),
          title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
        });
      } else handleResponseError(error);
    }
  };

  const handleSetField = (value: string) => {
    type === 'BET_GAME'
      ? dispatch(changeSingleAmount({ id, amount: Number(value) }))
      : dispatch(changeSingleFutureAmount({ id, amount: Number(value) }));
  };

  const handleDoubleClickOption = (value: string) => {
    showConfirmModal({
      content: (
        <p>
          {t('confirmModal.bet', {
            amount: `${value} ${currentUser?.coinDto?.symbol === 'USD' ? 'USD' : '$TBET'}`,
          })}
        </p>
      ),
      width: 360,
      icon: <InfomationIcon />,
      onOk: () => {
        onOk(value);
      },
      okText: 'Submit',
      cancelText: 'Cancel',
    });
  };

  return isLoading ? (
    <div className="overlay z-max">
      <LoadingSpinner />
    </div>
  ) : (
    <div className="single-bet__item">
      {type === 'BET_GAME' ? (
        <>
          <BetSlipInformationItem id={id} onDelete={onDelete} type={type} betType="Single" />
          {/* <div className="turbo">
            <CustomAmounBettButton
              onSetField={handleSetField}
              onOptionDoubleClick={handleDoubleClickOption}
            />
          </div> */}
        </>
      ) : (
        <>
          <FutureBetInformationItem id={id} onDelete={onDelete} />
        </>
      )}
    </div>
  );
};

export default SingleBetItem;
